import script from "./InsightCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightCard.vue?vue&type=script&setup=true&lang=js"

import "./InsightCard.vue?vue&type=style&index=0&id=36ba0352&lang=scss&scoped=true"
import "./InsightCard.vue?vue&type=style&index=1&id=36ba0352&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ba0352"]])

export default __exports__